import {useCallback, useMemo} from "react";
import Button from "../button/Button";
import Select from "../select/Select";
import {useTranslation} from "react-i18next";

export default function AsyncTablePagination({
    page,
    setPage,
    limit,
    setLimit,
    maxItems,
    disabled,
    summary,
}) {
    const {t} = useTranslation();

    const maxPages = useMemo(() => {
        return Math.ceil(maxItems / limit);
    }, [limit, maxItems]);

    const displayAmount = useMemo(() => {
        if (maxItems === 0) return "0 - 0";
        const start = (page - 1) * limit + 1;
        const end = Math.min(page * limit, maxItems);
        return `${start} - ${end}`;
    }, [limit, page, maxItems]);

    const onFirstPage = useCallback(() => {
        setPage(1);
    }, [setPage]);

    const onPreviousPage = useCallback(() => {
        setPage((prev) => prev - 1);
    }, [setPage]);

    const onNextPage = useCallback(() => {
        setPage((prev) => prev + 1);
    }, [setPage]);

    const onLastPage = useCallback(() => {
        setPage(maxPages);
    }, [setPage, maxPages]);

    const selectOptions = useMemo(() => {
        return [10, 25, 50, 100].map((value) => ({
            value,
            name: value.toString(),
        }));
    }, []);

    return (
        <div className="pagination">
            <div>
                {/* summary - własny opis zakresu, np. "Nr zwierzęcia 1–10 z 37 · Gr. 40" w grupie */}
                {summary ??
                    t("tableGrid.displaying", {
                        type1: displayAmount,
                        type2: maxItems,
                    })}
            </div>
            <div>
                <Button
                    buttonStyle={"round"}
                    icon={<i className="fa-solid fa-step-backward" />}
                    disabled={page === 1 || disabled}
                    onClick={onFirstPage}
                    type="button"
                />
                <Button
                    buttonStyle={"round"}
                    icon={<i className="fa-solid fa-backward" />}
                    disabled={page === 1 || disabled}
                    onClick={onPreviousPage}
                    type="button"
                />
                <div>
                    {maxPages === 0 ? "0" : page}/{maxPages}
                </div>
                <Button
                    buttonStyle={"round"}
                    icon={<i className="fa-solid fa-forward" />}
                    disabled={page === maxPages || maxPages === 0 || disabled}
                    onClick={onNextPage}
                    type="button"
                />
                <Button
                    buttonStyle={"round"}
                    icon={<i className="fa-solid fa-step-forward" />}
                    disabled={page === maxPages || maxPages === 0 || disabled}
                    onClick={onLastPage}
                    type="button"
                />
                <Select
                    options={selectOptions}
                    value={limit}
                    onChange={setLimit}
                    clearButton={false}
                    disabled={disabled}
                />
            </div>
        </div>
    );
}
